import * as React from "react";
import { useEffect } from "react";
import PropTypes from "prop-types";

const VoiceModeDialog = React.memo(function VoiceModeDialog({
  open,
  onClose,
  children,
  onDialogOpen,
  onDialogClose,
}) {
  useEffect(() => {
    if (open) {
      onDialogOpen?.();
    } else {
      onDialogClose?.();
    }
  }, [open, onDialogOpen, onDialogClose]);

  if (!open) return null;
  return (
    <div
      className="
        fixed inset-0 z-50 flex items-center justify-center
        bg-gradient-to-b from-white to-[#e7eee9]
      "
    >
      <div className="relative bg-transparent w-full h-full flex items-center justify-center">
        <div className="w-full max-w-2xl h-[80vh] flex flex-col justify-between animate-in fade-in p-0">
          <div className="flex-1 w-full flex flex-col justify-center items-center pb-[40px] pt-4">
            {children[0]}
          </div>
          <div className="w-full flex flex-col items-center pb-6">
            {children[1]}
          </div>
        </div>
      </div>
    </div>
  );
});

VoiceModeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onDialogOpen: PropTypes.func,
  onDialogClose: PropTypes.func,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default VoiceModeDialog;
